import { Dispatch } from 'redux';

import { post } from '@eika-infrastruktur/request';

import { ContactFormParams } from '../../generated-types';
import { Action } from './types';

type asyncDispatch = import('./types').asyncDispatch;

export const CONTEXT_PATH = '/dagligbank-kontakt-meg-web';
export const SERVICE_PATH = 'rest/resource';
export const FULL_PATH = `${CONTEXT_PATH}/${SERVICE_PATH}`;

export const REGISTER_PENDING = 'REGISTER_PENDING';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAILED = 'REGISTER_FAILED';
export const RESET_STATE = 'RESET_STATE';
export const CONFIRMATION_PENDING = 'CONFIRMATION_PENDING';

export type KontaktMegActionTypes =
    | RegisterPendingAction
    | RegisterSuccessAction
    | RegisterFailedAction
    | ResetStateAction
    | ConfirmationPendingAction;

export interface RegisterPendingAction extends Action<typeof REGISTER_PENDING> {
    type: typeof REGISTER_PENDING;
}

export interface RegisterSuccessAction extends Action<typeof REGISTER_SUCCESS> {
    type: typeof REGISTER_SUCCESS;
}

export interface RegisterFailedAction extends Action<typeof REGISTER_FAILED> {
    type: typeof REGISTER_FAILED;
    error: Error;
}

export interface ResetStateAction extends Action<typeof RESET_STATE> {
    type: typeof RESET_STATE;
}

export interface ConfirmationPendingAction extends Action<typeof CONFIRMATION_PENDING> {
    type: typeof CONFIRMATION_PENDING;
}

export const registerPendingAction = () => ({
    type: REGISTER_PENDING,
});

export const confirmationPendingAction = () => ({
    type: CONFIRMATION_PENDING,
});

export const registerFailedAction = (error: Error) => ({
    type: REGISTER_FAILED,
    error,
});

export const registerSuccessAction = () => ({
    type: REGISTER_SUCCESS,
});

export const resetStateAction = () => ({
    type: RESET_STATE,
});

export type registerKontaktMegType = (selectedTema: string, textAreaContent: string) => asyncDispatch;

export const resetState = (): asyncDispatch => async (dispatch: Dispatch) => {
    dispatch(resetStateAction());
};

export type registerContactType = (params: ContactFormParams) => asyncDispatch;

export const registerContact: registerContactType = (params) => async (dispatch: Dispatch) => {
    dispatch(registerPendingAction());
    try {
        await post(`${FULL_PATH}/kontakt/contactform`, params);
        dispatch(registerSuccessAction());
    } catch (e) {
        dispatch(registerFailedAction(e as any)); // eslint-disable-line
    }
};
